import Axios from 'axios';
import qs from 'qs';

export const CONTENT_TYPE = 'Content-Type';

export const FORM_URLENCODED = 'application/x-www-form-urlencoded; charset=UTF-8';

export const APPLICATION_JSON = 'application/json; charset=UTF-8';

export const apiUrl = {
  dev: 'http://120.76.77.155:9999',
  pro: 'http://120.76.77.155:9999',
};
// pro: 'http://huayue-api.test.jobs123.cn',

const service = Axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? apiUrl['pro'] : apiUrl['dev'],
  timeout: 10 * 60 * 1000,
});

service.interceptors.request.use(
  config => {
    !config.headers && (config.headers = {});
    if (!config.headers[CONTENT_TYPE]) {
      config.headers[CONTENT_TYPE] = APPLICATION_JSON;
    }
    if (config.headers[CONTENT_TYPE] === FORM_URLENCODED) {
      config.data = qs.stringify(config.data);
    }
    return config;
  },
  error => {
    return Promise.reject(error.response);
  }
);

service.interceptors.response.use(
  response => {
    const { code, } = response.data;
    if (response.data.type) {
      return response;
    }
    if (response.data.error == 0) {
      return response.data;
    }
    if (code === 200) {
      return response.data;
    } else {
      throw new Error('失败');
    }
  },
  error => {
    console.log(error);
    return Promise.reject({ code: 500, msg: '', });
  }
);

export default service;
